// @flow
import * as ActionTypes from 'constants/ActionTypes';

const initialState = {
  serviceError: "",
  serviceCode: 200,
  reqStatus: "",
  isLoading: false,
  isSyncing: false,
  syncResult: null,
  isCreatingProducts: false,
  createProductsResult: null,
  isAddingVideo: false,
  addVideoResult: null,
  isUpdatingFollowers: false,
  updateFollowersResult: null,
  instagramMedia: {
    shop_id: null,
    shop_name: "",
    instahandle: "",
    media: [],
    pagination: {
      current_page: 1,
      per_page: 50,
      total: 0,
      total_pages: 0
    }
  },
  instagramStats: {
    shop_id: null,
    shop_name: "",
    instahandle: "",
    instagram_followers_count: 0,
    instagram_last_synced: null,
    statistics: {
      total_media: 0,
      total_likes: 0,
      total_comments: 0,
      avg_likes: 0,
      avg_comments: 0
    }
  }
};

export default function (state: Object = initialState, action: Object) {
  switch (action.type) {
    /* Start Triggers */
    case ActionTypes.ADMIN_GET_INSTAGRAM_MEDIA_START:
    case ActionTypes.ADMIN_GET_INSTAGRAM_MEDIA_STATS_START: {
      return {
        ...state,
        isLoading: true,
        reqStatus: action.type,
        serviceError: "",
      };
    }

    case ActionTypes.ADMIN_SYNC_INSTAGRAM_MEDIA_START: {
      return {
        ...state,
        isSyncing: true,
        reqStatus: action.type,
        serviceError: "",
        syncResult: null,
      };
    }

    case ActionTypes.ADMIN_CREATE_PRODUCTS_FROM_INSTAGRAM_START: {
      return {
        ...state,
        isCreatingProducts: true,
        reqStatus: action.type,
        serviceError: "",
        createProductsResult: null,
      };
    }

    case ActionTypes.ADMIN_ADD_VIDEO_TO_PRODUCT_START: {
      return {
        ...state,
        isAddingVideo: true,
        reqStatus: action.type,
        serviceError: "",
        addVideoResult: null,
      };
    }

    case ActionTypes.ADMIN_UPDATE_SHOP_FOLLOWERS_START: {
      return {
        ...state,
        isUpdatingFollowers: true,
        reqStatus: action.type,
        serviceError: "",
        updateFollowersResult: null,
      };
    }

    /* Failures */
    case ActionTypes.ADMIN_GET_INSTAGRAM_MEDIA_FAILURE:
    case ActionTypes.ADMIN_GET_INSTAGRAM_MEDIA_STATS_FAILURE: {
      return {
        ...state,
        isLoading: false,
        reqStatus: action.type,
        serviceError: { ...action.payload },
      };
    }

    case ActionTypes.ADMIN_SYNC_INSTAGRAM_MEDIA_FAILURE: {
      return {
        ...state,
        isSyncing: false,
        reqStatus: action.type,
        serviceError: { ...action.payload },
      };
    }

    case ActionTypes.ADMIN_CREATE_PRODUCTS_FROM_INSTAGRAM_FAILURE: {
      return {
        ...state,
        isCreatingProducts: false,
        reqStatus: action.type,
        serviceError: { ...action.payload },
      };
    }

    case ActionTypes.ADMIN_ADD_VIDEO_TO_PRODUCT_FAILURE: {
      return {
        ...state,
        isAddingVideo: false,
        reqStatus: action.type,
        serviceError: { ...action.payload },
      };
    }

    case ActionTypes.ADMIN_UPDATE_SHOP_FOLLOWERS_FAILURE: {
      return {
        ...state,
        isUpdatingFollowers: false,
        reqStatus: action.type,
        serviceError: { ...action.payload },
      };
    }

    /* Success Handlers */
    case ActionTypes.ADMIN_GET_INSTAGRAM_MEDIA_SUCCESS: {
      if (action.payload.statusCode === 200) {
        return {
          ...state,
          isLoading: false,
          reqStatus: action.type,
          serviceError: "",
          serviceCode: action.payload.statusCode,
          instagramMedia: action.payload.response
        };
      } else {
        return {
          ...state,
          isLoading: false,
          reqStatus: action.type,
          serviceError: action.payload.statusMessage,
          serviceCode: action.payload.statusCode,
        };
      }
    }

    case ActionTypes.ADMIN_GET_INSTAGRAM_MEDIA_STATS_SUCCESS: {
      if (action.payload.statusCode === 200) {
        return {
          ...state,
          isLoading: false,
          reqStatus: action.type,
          serviceError: "",
          serviceCode: action.payload.statusCode,
          instagramStats: action.payload.response
        };
      } else {
        return {
          ...state,
          isLoading: false,
          reqStatus: action.type,
          serviceError: action.payload.statusMessage,
          serviceCode: action.payload.statusCode,
        };
      }
    }

    case ActionTypes.ADMIN_SYNC_INSTAGRAM_MEDIA_SUCCESS: {
      if (action.payload.statusCode === 200) {
        return {
          ...state,
          isSyncing: false,
          reqStatus: action.type,
          serviceError: "",
          serviceCode: action.payload.statusCode,
          syncResult: action.payload.response
        };
      } else {
        return {
          ...state,
          isSyncing: false,
          reqStatus: action.type,
          serviceError: action.payload.statusMessage,
          serviceCode: action.payload.statusCode,
        };
      }
    }

    case ActionTypes.ADMIN_CREATE_PRODUCTS_FROM_INSTAGRAM_SUCCESS: {
      return {
        ...state,
        isCreatingProducts: false,
        reqStatus: action.type,
        serviceError: "",
        serviceCode: 200,
        createProductsResult: action.payload
      };
    }

    case ActionTypes.ADMIN_ADD_VIDEO_TO_PRODUCT_SUCCESS: {
      if (action.payload.statusCode === 200) {
        return {
          ...state,
          isAddingVideo: false,
          reqStatus: action.type,
          serviceError: "",
          serviceCode: action.payload.statusCode,
          addVideoResult: action.payload.response
        };
      } else {
        return {
          ...state,
          isAddingVideo: false,
          reqStatus: action.type,
          serviceError: action.payload.statusMessage,
          serviceCode: action.payload.statusCode,
        };
      }
    }

    case ActionTypes.ADMIN_UPDATE_SHOP_FOLLOWERS_SUCCESS: {
      if (action.payload.statusCode === 200) {
        const updatedData = action.payload.response;
        return {
          ...state,
          isUpdatingFollowers: false,
          reqStatus: action.type,
          serviceError: "",
          serviceCode: action.payload.statusCode,
          updateFollowersResult: updatedData,
          instagramStats: {
            ...state.instagramStats,
            instagram_followers_count: updatedData.instagram_followers_count || state.instagramStats.instagram_followers_count,
            instagram_last_synced: updatedData.instagram_last_synced || state.instagramStats.instagram_last_synced,
          }
        };
      } else {
        return {
          ...state,
          isUpdatingFollowers: false,
          reqStatus: action.type,
          serviceError: action.payload.statusMessage,
          serviceCode: action.payload.statusCode,
        };
      }
    }

    default:
      return state;
  }
}

